"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UnsafeUrl = require("../utils/UnsafeUrl");

var _validHref = _interopRequireDefault(require("../utils/propTypes/validHref"));

var _ThrowError = require("../utils/ThrowError");

var _Functions = require("../core/Functions");

var _Styles = require("../utils/Styles");

var _Timers = require("../utils/Timers");

var SHAPE_CLASSES = {
  default: '',
  circle: 'img-circle private-image--circle',
  rounded: 'img-rounded private-image--rounded',
  thumbnail: 'img-thumbnail private-image--thumbnail'
};
var OBJECT_FIT_CLASSES = {
  fill: '',
  contain: 'private-image--object-fit-contain'
};

var _default = _react.default.createClass({
  displayName: "UIImage",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    alt: _react.PropTypes.string.isRequired,
    bordered: _react.PropTypes.bool.isRequired,
    height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    onError: _react.PropTypes.func,
    onLoad: _react.PropTypes.func,
    objectFit: _react.PropTypes.oneOf(Object.keys(OBJECT_FIT_CLASSES)).isRequired,
    responsive: _react.PropTypes.bool.isRequired,
    shape: _react.PropTypes.oneOf(Object.keys(SHAPE_CLASSES)).isRequired,
    src: _validHref.default.isRequired,
    width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
  },
  getDefaultProps: function getDefaultProps() {
    return {
      alt: '',
      bordered: false,
      objectFit: 'fill',
      responsive: true,
      shape: 'default'
    };
  },
  getInitialState: function getInitialState() {
    return {
      computedStyle: this.props.style,
      loadFailed: false,
      overrides: {}
    };
  },
  componentDidMount: function componentDidMount() {
    requestAnimationFrame(this.polyfillObjectFit);
    window.addEventListener('resize', this.delayedPolyfillObjectFit);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var overrides = this.state.overrides;
    this.setState({
      computedStyle: (0, _extends2.default)({}, nextProps.style, overrides)
    });
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.overrides === this.state.overrides) {
      this.polyfillObjectFit();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('resize', this.delayedPolyfillObjectFit);
  },
  handleImageError: function handleImageError(evt) {
    var onError = this.props.onError;
    this.setState({
      loadFailed: true
    });
    (0, _Functions.callIfPossible)(onError, evt);
  },
  handleImageLoad: function handleImageLoad(evt) {
    var onLoad = this.props.onLoad;
    this.setState({
      loadFailed: false
    });
    (0, _Functions.callIfPossible)(onLoad, evt);
  },
  delayedPolyfillObjectFit: function delayedPolyfillObjectFit() {
    (0, _Timers.cancelIdleCallback)(this._timeout); // Ensure only one callback is queued at a time

    this._timeout = (0, _Timers.requestIdleCallback)(this.polyfillObjectFit);
  },
  polyfillObjectFit: function polyfillObjectFit() {
    var _this$props = this.props,
        objectFit = _this$props.objectFit,
        style = _this$props.style;

    if (!('objectFit' in document.documentElement.style) && objectFit === 'contain' && document.body && this._img) {
      var _this$_img = this._img,
          naturalWidth = _this$_img.naturalWidth,
          naturalHeight = _this$_img.naturalHeight;
      if (!naturalWidth || !naturalHeight) return;
      var imgAspectRatio = naturalWidth / naturalHeight; // Reset existing overrides on <img>

      var imgStyles = this._img.style;
      var originalImgWidth = imgStyles.width;
      var originalImgHeight = imgStyles.height;

      if (this.state.overrides.width) {
        imgStyles.width = style ? (0, _Styles.toPx)(style.width) : '';
      } else if (this.state.overrides.height) {
        imgStyles.height = style ? (0, _Styles.toPx)(style.height) : '';
      }

      var _this$_img$getBoundin = this._img.getBoundingClientRect(),
          renderedWidth = _this$_img$getBoundin.width,
          renderedHeight = _this$_img$getBoundin.height;

      var fittedHeight = renderedWidth / imgAspectRatio;
      var fittedWidth = renderedHeight * imgAspectRatio;
      var overrides = {};

      if (renderedHeight > fittedHeight) {
        overrides = {
          height: fittedHeight
        };
      } else if (renderedWidth > fittedWidth) {
        overrides = {
          width: fittedWidth
        };
      }

      imgStyles.width = originalImgWidth;
      imgStyles.height = originalImgHeight;
      this.updateOverrides(overrides);
    }
  },
  updateOverrides: function updateOverrides(overrides) {
    var style = this.props.style;
    this.setState({
      computedStyle: (0, _extends2.default)({}, style, overrides),
      overrides: overrides
    });
  },
  getClassName: function getClassName(_ref) {
    var bordered = _ref.bordered,
        className = _ref.className,
        objectFit = _ref.objectFit,
        responsive = _ref.responsive,
        shape = _ref.shape;
    return (0, _classNames.default)('private-image', SHAPE_CLASSES[shape], OBJECT_FIT_CLASSES[objectFit], className, {
      'img-responsive private-image--responsive': responsive,
      'image-load-failed': this.state.loadFailed,
      'private-image--bordered': bordered
    });
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        alt = _this$props2.alt,
        bordered = _this$props2.bordered,
        className = _this$props2.className,
        objectFit = _this$props2.objectFit,
        responsive = _this$props2.responsive,
        shape = _this$props2.shape,
        src = _this$props2.src,
        __style = _this$props2.style,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["alt", "bordered", "className", "objectFit", "responsive", "shape", "src", "style"]);

    if ((0, _UnsafeUrl.isUnsafeUrl)(src)) {
      (0, _ThrowError.throwErrorAsync)(new Error("UIImage: Detected XSS attempt! src=\"" + src + "\""));
    }

    var computedStyle = this.state.computedStyle;
    return _react.default.createElement("img", (0, _extends2.default)({}, rest, {
      alt: alt,
      className: this.getClassName({
        bordered: bordered,
        className: className,
        objectFit: objectFit,
        responsive: responsive,
        shape: shape
      }),
      key: src,
      onError: this.handleImageError,
      onLoad: this.handleImageLoad,
      ref: function ref(_ref2) {
        _this._img = _ref2;
      },
      src: (0, _UnsafeUrl.isUnsafeUrl)(src) ? null : src,
      style: computedStyle
    }));
  }
});

exports.default = _default;
module.exports = exports.default;